import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Stack from '@eversports/klimt-primitives/legacy/Stack/Stack'

import { EventBookableItem, EventSession } from '../ActivityDetails.types'
import ContentWrapper from '../components/ContentWrapper'
import FriendsAttending from '../FriendAttending'

import CallToAction from './CallToAction'
import DateTimeAvailability from './DateTimeAvailability'
import RevealedActivityName from './RevealedActivityName'
import { SpotBooking } from './SpotBooking'
import TrainerInfo from './TrainerInfo'

interface Props {
  activity: EventBookableItem
  eventSessions: Array<EventSession>
}

const Sidebar = ({ activity, eventSessions }: Props) => {
  const {
    id,
    activityName,
    venue,
    eventType,
    availableSpots,
    registrationWindow,
    registrationWindowState,
    trainers,
    registrationState,
    floorPlan,
  } = activity
  const hasOneTrainer = trainers.length === 1

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const hasSpotBooking = Boolean(floorPlan?.id)

  return (
    <ContentWrapper
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        top: { md: '72px' },
        height: { md: 'fit-content' },
        minWidth: { md: 250 },
        maxWidth: { md: 300 },
        zIndex: 3,
        bottom: { xs: 0, md: 'auto' },
        gap: 0,
      }}
    >
      {!isMobile && <RevealedActivityName activityName={activityName} />}
      <Stack sx={{ gap: 4, mb: 4, display: { xs: 'none', md: 'flex' } }}>
        <DateTimeAvailability
          eventSessions={eventSessions}
          availableSpots={availableSpots}
          registrationState={registrationState}
        />
        {hasSpotBooking && <SpotBooking goToPreviewSpot={`/activity/${activity.id}/spots`} />}
        {hasOneTrainer && <TrainerInfo trainer={trainers[0]} eventType={eventType} />}
        <FriendsAttending activityId={activity.id} />
      </Stack>
      <CallToAction
        bookableItemId={id}
        venueId={venue.id}
        availableSpots={availableSpots}
        registrationState={registrationState}
        registrationWindowState={registrationWindowState}
        registrationWindow={registrationWindow}
      />
    </ContentWrapper>
  )
}

export default Sidebar
